/**
 * Forms
 */

// Dependencies
import $ from 'jquery';
require('chosen-js');
require('parsleyjs');

import numLock from './numLock';

// Cached elements
const $el = {
	form: $('.js-validate'),
	dropdown: $('.js-dropdown'),
	ajaxForm: $('.js-ajax-form'),
	newsletter: $('.js-newsletter'),
};

const chosenOptions = {
	disable_search: true,
	inherit_select_classes: true,
	width: '100%'
};

const parsleyOptions = {
	classHandler: (ParsleyField) => {
		return ParsleyField.$element.parent();
	},
	excluded: 'input[type=submit], input[type=reset], input[type=checkbox]:not(.js-validate)'
};

export default function init() {

	// Initialise Chosen
	if ($el.dropdown.length) $el.dropdown.chosen(chosenOptions);

	// Parsley Validation
	if ($el.form.length) $el.form.parsley(parsleyOptions);

	numLock();

	$el.ajaxForm.each(function() {

	    $(this).on({
	        submit: function () {
	            var $self = $(this);

	            $("button[type=submit]", $self).prop("disabled", true);
	            var $loader = $("<div class='c-loader'></div>"); 
	            $self.find("fieldset").append($loader);

	            $.ajax({
	                url: $("input[name=action]", $(this)).val(),
	                type: "post",
	                dataType: "json",
	                data: $(this).serialize(),
	                success: function (response) {
	                    if (response.success && response.finished) {
	                        $self[0].reset();
	                        $self.find(".c-loader").remove();
	                        var $successMessage = $("<div class='c-form-success'>Thank you message goes here</div>"); 
	                        $self.find("fieldset").append($successMessage);
	                    } else if (response.errors) {
	                        for (var key in response.errors) {
	                            if (!response.errors.hasOwnProperty(key)) continue;
	                            var messages = response.errors[key];
	                            var $errors  = $("<ul>", {"class": "errors help-block"});
	                            for (var i = 0; i < messages.length; i++) {
	                                var $li = $("<li>");
	                                $li.html(messages[i]);
	                                $errors.append($li);
	                            }

	                            var $input = $("*[name=" + key + "], *[name='" + key + "[]']");

	                            const $formGroup = $input.parents(".form-group");
	                            $formGroup.addClass("has-error");

	                            $formGroup.append($errors);
	                        }
	                    }

	                    $("button[type=submit]", $self).prop("disabled", false);
	                }
	            });

	            return false;
	        }
	    });

	});

	$el.newsletter.submit(function() {
		if ($el.newsletter.parsley().isValid()) {
			$.fancybox.close(true);
		}
	});

}

